export const metaDataMap = {
  api: {
    title: 'META_DATA.API.META_TITLE',
    description: 'META_DATA.API.META_DESCRIPTION'
  },
  data: {
    title: 'META_DATA.DATA.META_TITLE',
    description: 'META_DATA.DATA.META_DESCRIPTION'
  },
  solutions: {
    title: 'META_DATA.SOLUTIONS.META_TITLE',
    description: 'META_DATA.SOLUTIONS.META_DESCRIPTION'
  },
  search: {
    title: 'META_DATA.SEARCH.META_TITLE',
    description: 'META_DATA.SEARCH.META_DESCRIPTION'
  },
  'get-in-touch': {
    title: 'META_DATA.GET_IN_TOUCH.META_TITLE',
    description: 'META_DATA.GET_IN_TOUCH.META_DESCRIPTION'
  },
  'about-us': {
    title: 'META_DATA.ABOUT_US.META_TITLE',
    description: 'META_DATA.ABOUT_US.META_DESCRIPTION'
  },
  services: {
    title: 'META_DATA.SERVICES.META_TITLE',
    description: 'META_DATA.SERVICES.META_DESCRIPTION'
  },
  'contact-us': {
    title: 'META_DATA.CONTACT_US.META_TITLE',
    description: 'META_DATA.CONTACT_US.META_DESCRIPTION'
  },
  hardware: {
    title: 'META_DATA.HARDWARE.META_TITLE',
    description: 'META_DATA.HARDWARE.META_DESCRIPTION'
  },
  listing: {
    title: 'META_DATA.LISTING.META_TITLE',
    description: 'META_DATA.LISTING.META_DESCRIPTION'
  },
  support: {
    title: 'META_DATA.SUPPORT.META_TITLE',
    description: 'META_DATA.SUPPORT.META_DESCRIPTION'
  },
  'product-guides': {
    title: 'META_DATA.PRODUCT_GUIDES.META_TITLE',
    description: 'META_DATA.PRODUCT_GUIDES.META_DESCRIPTION'
  },
  'product-videos': {
    title: 'META_DATA.PRODUCT_VIDEOS.META_TITLE',
    description: 'META_DATA.PRODUCT_VIDEOS.META_DESCRIPTION'
  },
  'cloud-infrastructure': {
    title: 'META_DATA.CLOUD_INFRASTRUCTURE.META_TITLE',
    description: 'META_DATA.CLOUD_INFRASTRUCTURE.META_DESCRIPTION'
  },
  'managed-services': {
    title: 'META_DATA.MANAGED_SERVICES.META_TITLE',
    description: 'META_DATA.MANAGED_SERVICES.META_DESCRIPTION'
  },
  'enterprise-licensing': {
    title: 'META_DATA.ENTERPRISE_LICENSING.META_TITLE',
    description: 'META_DATA.ENTERPRISE_LICENSING.META_DESCRIPTION'
  },
  'iot-software-services': {
    title: 'META_DATA.IOT_SOFTWARE_SERVICES.META_TITLE',
    description: 'META_DATA.IOT_SOFTWARE_SERVICES.META_DESCRIPTION'
  },
  'professional-services': {
    title: 'META_DATA.PROFESSIONAL_SERVICES.META_TITLE',
    description: 'META_DATA.PROFESSIONAL_SERVICES.META_DESCRIPTION'
  },
  'communication-services': {
    title: 'META_DATA.COMMUNICATION_SERVICES.META_TITLE',
    description: 'META_DATA.COMMUNICATION_SERVICES.META_DESCRIPTION'
  },
  'iot-&-ai': {
    title: 'META_DATA.IOT_&_AI.META_TITLE',
    description: 'META_DATA.IOT_&_AI.META_DESCRIPTION'
  },
  'location-&-mapping': {
    title: 'META_DATA.LOCATION_&_MAPPING.META_TITLE',
    description: 'META_DATA.LOCATION_&_MAPPING.META_DESCRIPTION'
  },
  'smart-city': {
    title: 'META_DATA.SMART_CITY.META_TITLE',
    description: 'META_DATA.SMART_CITY.META_DESCRIPTION'
  },
  fintech: {
    title: 'META_DATA.FINTECH.META_TITLE',
    description: 'META_DATA.FINTECH.META_DESCRIPTION'
  },
  parking: {
    title: 'META_DATA.PARKING.META_TITLE',
    description: 'META_DATA.PARKING.META_DESCRIPTION'
  },
  environment: {
    title: 'META_DATA.ENVIRONMENT.META_TITLE',
    description: 'META_DATA.ENVIRONMENT.META_DESCRIPTION'
  },
  government: {
    title: 'META_DATA.GOVERNMENT.META_TITLE',
    description: 'META_DATA.GOVERNMENT.META_DESCRIPTION'
  },
  'route-planning': {
    title: 'META_DATA.ROUTE_PLANNING.META_TITLE',
    description: 'META_DATA.ROUTE_PLANNING.META_DESCRIPTION'
  },
  'fuel-&-charging': {
    title: 'META_DATA.FUEL_&_CHARGING.META_TITLE',
    description: 'META_DATA.FUEL_&_CHARGING.META_DESCRIPTION'
  },
  verification: {
    title: 'META_DATA.VERIFICATION.META_TITLE',
    description: 'META_DATA.VERIFICATION.META_DESCRIPTION'
  },
  'logistics-&-fleet': {
    title: 'META_DATA.LOGISTICS_&_FLEET.META_TITLE',
    description: 'META_DATA.LOGISTICS_&_FLEET.META_DESCRIPTION'
  },
  'fleet-management': {
    title: 'META_DATA.FLEET_MANAGEMENT.META_TITLE',
    description: 'META_DATA.FLEET_MANAGEMENT.META_DESCRIPTION'
  },
  'vehicle-data-analytics': {
    title: 'META_DATA.VEHICLE_DATA_ANALYTICS.META_TITLE',
    description: 'META_DATA.VEHICLE_DATA_ANALYTICS.META_DESCRIPTION'
  },
  others: {
    title: 'META_DATA.OTHERS.META_TITLE',
    description: 'META_DATA.OTHERS.META_DESCRIPTION'
  },
  'data-protection-policy': {
    title: 'META_DATA.DATA_PROTECTION_NOTICE.META_TITLE',
    description: 'META_DATA.DATA_PROTECTION_NOTICE.META_DESCRIPTION'
  },
  'corporate-information': {
    title: 'META_DATA.CORPORATE_INFORMATION.META_TITLE',
    description: 'META_DATA.CORPORATE_INFORMATION.META_DESCRIPTION'
  },
  'terms-of-use': {
    title: 'META_DATA.TERMS_AND_CONDITIONS.META_TITLE',
    description: 'META_DATA.TERMS_AND_CONDITIONS.META_DESCRIPTION'
  },
  'legal-notice': {
    title: 'META_DATA.LEGAL_NOTICE.META_TITLE',
    description: 'META_DATA.LEGAL_NOTICE.META_DESCRIPTION'
  },
  default: {
    title: 'META_DATA.HOME.META_TITLE',
    description: 'META_DATA.HOME.META_DESCRIPTION'
  }
};
